// Utility to parse, normalize and validate recipient emails from freeform input
export default function parseRecipients(input: string): { valid: string[]; invalid: string[] } {
  if (!input) return { valid: [], invalid: [] };

  // Split on newlines, commas, and semicolons to preserve tokens like
  // "Name <email@domain>" while still allowing space-separated emails
  const tokens = input
    .split(/[\n,;]+/)
    .map((t) => t.trim())
    .filter(Boolean);

  // Basic but practical email extractor (finds emails even inside angle brackets)
  const emailPattern = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;

  const validSet = new Set<string>();
  const invalidSet = new Set<string>();

  for (const token of tokens) {
    const matches = token.match(emailPattern);
    if (matches && matches.length > 0) {
      // A token can contain multiple addresses (e.g. "a@b.com b@c.com")
      for (const m of matches) {
        validSet.add(m.trim().toLowerCase());
      }
    } else {
      invalidSet.add(token);
    }
  }

  return { valid: Array.from(validSet), invalid: Array.from(invalidSet) };
}
